unit uArchivoDWK;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.JSON,
  WEBLib.StdCtrls, System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage, WEBLib.Calendar, WebLib.Utils, WEBLib.JQCtrls;

type
  TFArchivoDWK = class(TForm)
    WebDBGrid1: TDBGrid;
    WebSpeedButton11: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    CSolicitudHdr: TClientConnection;
    TSolicitudHdr: TClientDataSet;
    DsSolicitudHdr: TDataSource;
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebSpeedButton11Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  FArchivoDWK: TFArchivoDWK;

implementation

{$R *.dfm}

procedure TFArchivoDWK.WebFormCreate(Sender: TObject);
begin
CSolicitudHdr.Command := httpGET;
CSolicitudHdr.URI := 'http://207.244.241.82:9000/SolicitudHdr';
CSolicitudHdr.Active := True;
end;

procedure TFArchivoDWK.WebSpeedButton10Click(Sender: TObject);
begin
FArchivoDWK.Hide;
end;

procedure TFArchivoDWK.WebSpeedButton11Click(Sender: TObject);
Var
Data: TJSONObject;
Folio, URL: string;
begin
Folio:=TSolicitudHdr.FieldByName('Folio').AsString;
URL := 'http://207.244.241.82:9000/PDFReporteDwk?FOLIO=' + Folio;
  asm
  window.open(URL, '_blank');
  end;


end;

procedure TFArchivoDWK.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebDBGrid1 := TDBGrid.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  CSolicitudHdr := TClientConnection.Create(Self);
  TSolicitudHdr := TClientDataSet.Create(Self);
  DsSolicitudHdr := TDataSource.Create(Self);

  WebDBGrid1.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  CSolicitudHdr.BeforeLoadDFMValues;
  TSolicitudHdr.BeforeLoadDFMValues;
  DsSolicitudHdr.BeforeLoadDFMValues;
  try
    Name := 'FArchivoDWK';
    Width := 1366;
    Height := 745;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebDBGrid1.SetParentComponent(Self);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 17;
    WebDBGrid1.Top := 46;
    WebDBGrid1.Width := 944;
    WebDBGrid1.Height := 683;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Folio';
      Title := 'Folio';
      Width := 120;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'FechaPedido';
      Title := 'Fecha';
      Width := 120;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Nombre';
      Title := 'Solicitante';
      Width := 300;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Nombre2';
      Title := 'Capacitador';
      Width := 300;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Cerrado';
      Title := 'En proceso';
    end;
    WebDBGrid1.DataSource := DsSolicitudHdr;
    WebDBGrid1.FixedCols := 0;
    WebDBGrid1.TabOrder := 0;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 120;
    WebDBGrid1.ColWidths[1] := 120;
    WebDBGrid1.ColWidths[2] := 300;
    WebDBGrid1.ColWidths[3] := 300;
    WebDBGrid1.ColWidths[4] := 64;
    WebSpeedButton11.SetParentComponent(Self);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 967;
    WebSpeedButton11.Top := 46;
    WebSpeedButton11.Width := 119;
    WebSpeedButton11.Height := 44;
    WebSpeedButton11.Caption := 'Imprimir';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.Glyph.LoadFromFile('uArchivoDWK.WebSpeedButton11.Glyph.png');
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebSpeedButton10.SetParentComponent(Self);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 967;
    WebSpeedButton10.Top := 96;
    WebSpeedButton10.Width := 119;
    WebSpeedButton10.Height := 44;
    WebSpeedButton10.Caption := 'Salir';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uArchivoDWK.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    CSolicitudHdr.SetParentComponent(Self);
    CSolicitudHdr.Name := 'CSolicitudHdr';
    CSolicitudHdr.Active := False;
    CSolicitudHdr.Left := 1022;
    CSolicitudHdr.Top := 208;
    TSolicitudHdr.SetParentComponent(Self);
    TSolicitudHdr.Name := 'TSolicitudHdr';
    TSolicitudHdr.Connection := CSolicitudHdr;
    TSolicitudHdr.Left := 1022;
    TSolicitudHdr.Top := 160;
    DsSolicitudHdr.SetParentComponent(Self);
    DsSolicitudHdr.Name := 'DsSolicitudHdr';
    DsSolicitudHdr.DataSet := TSolicitudHdr;
    DsSolicitudHdr.Left := 1022;
    DsSolicitudHdr.Top := 256;
  finally
    WebDBGrid1.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    CSolicitudHdr.AfterLoadDFMValues;
    TSolicitudHdr.AfterLoadDFMValues;
    DsSolicitudHdr.AfterLoadDFMValues;
  end;
end;

end.